<template>
  <div>
    <v-layout wrap>
      <v-flex xs6>
        <h2 class="title grey--text mt-2">Working hours</h2>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-btn
          v-if="!isEdit"
          icon
          outline
          :loading="loading"
          color="primary"
          @click="isEdit = true"
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-card class="mt-2">
      <div class="pa-2 hidden-xs-only">
        <v-layout wrap>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Date_1') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Open at') }}</v-flex>
          <v-flex xs4 class="text-xs-center strong">{{ $t('Close at') }}</v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <template v-for="(time, key) in timetable">
        <open-time-bot-item
          :key="key"
          v-model="timetable[key]"
          :name="key"
          :is-edit="isEdit"
        ></open-time-bot-item>
      </template>
    </v-card>
    <div v-if="isEdit" class="text-xs-center mt-4">
      <v-btn color="grey" outline @click="onCancelTimeTable">{{ $t('cancel') }}</v-btn>
      <v-btn :loading="loading" depressed color="primary" @click="onSaveTimeTable">{{
        $t('Save')
      }}</v-btn>
    </div>
    <div class="mt-5">
      <DefaultMessage />
    </div>
  </div>
</template>

<script>
import ticket3AdminManagementApi from '@/api/ticket3/admin-management'
import { mapGetters } from 'vuex'
import OpenTimeBotItem from './OpenTimeBotItem'
import DefaultMessage from '@/components/view/template/ticket/defaultMessage'

import { handleApiError } from '@/api/util'

export default {
  name: 'WorkingHours',
  components: {
    OpenTimeBotItem,
    DefaultMessage
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      timetable: {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      },
      dayOfWeek: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      setting: 'setting'
    })
  },
  async mounted() {
    this.loading = true
    await this.handleGetTimeable()
    this.loading = false
  },
  methods: {
    async handleGetTimeable() {
      try {
        const response = await ticket3AdminManagementApi.getAdminWorkingHours({
          params: {
            page_id: this.selectedBot.pageid
          }
        })
        if (response.status == 200 && response.data.data) {
          const timetable = {}
          response.data.data.forEach((element) => {
            const dayName = this.toCapitalCase(this.dayOfWeek[element.day_of_week])
            const openat = element.open_at ? element.open_at.split('+')[0] : '00:00'
            const closeat = element.close_at ? element.close_at.split('+')[0] : '24:00'
            timetable[dayName] = {
              status: element.status,
              openat: element.open_at ? openat : null,
              closeat: element.close_at ? closeat : null
            }
          })
          this.timetable = timetable
        } else {
          this.timetable = {
            Monday: { status: true, openat: null, closeat: null },
            Tuesday: { status: true, openat: null, closeat: null },
            Wednesday: { status: true, openat: null, closeat: null },
            Thursday: { status: true, openat: null, closeat: null },
            Friday: { status: true, openat: null, closeat: null },
            Saturday: { status: true, openat: null, closeat: null },
            Sunday: { status: true, openat: null, closeat: null }
          }
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    handleGetDateNumber(date) {
      return this.dayOfWeek.indexOf(date.toLowerCase())
    },
    onCancelTimeTable: function () {
      const vm = this
      vm.isEdit = false
      vm.timetable = JSON.parse(vm.cached_timetable)
    },
    onSaveTimeTable: async function () {
      const vm = this
      const result = await vm.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }

      vm.loading = true
      try {
        await vm.saveApi(this.selectedBot.pageid)
      } catch (error) {
        handleApiError(error)
      } finally {
        vm.loading = false
      }
      vm.cached_timetable = JSON.stringify(vm.timetable)
      vm.isEdit = false
      return true
    },
    async saveApi(pageid) {
      var vm = this
      const timetable = vm.timetable
        ? Object.entries(vm.timetable).map((item) => {
            console.log(item)
            return {
              status: item[1].status ? true : false,
              open_at: item[1].openat || '00:00:00',
              close_at: item[1].closeat || '23:59:59',
              day_of_week: this.handleGetDateNumber(item[0])
            }
          })
        : []
      var data = {
        working_hours: timetable,
        page_id: pageid
      }
      return ticket3AdminManagementApi.putAdminWorkingHours({ data })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/user/WorkingHours/index.vue